import React, { useState, useEffect, } from "react";
import Tables from "../../../../components/Tables/Tables";
import Modal from "../../../../components/Modal/Modal";
import styled from "styled-components";
import Toast from "../../../../components/Toast/Toast";
import Modal2 from "../../../../components/Modal/Modal";
import Input from "../../../../components/Input/Input";
import {
  getClienteOptions,
  getEquiposOptions,
  deleteIntervecion,
  getIntervecionPaginated,
  getIntervecionSearch,
  getIntervencionByEquipo,
  getIntervencionByCliente,
  getIntervencionByClienteByEquipo,
  
  getPlantaOptions,
  getPlantaByClienteOptions,
  getIntervencionWithFilters,
} from "../../../../api/Clientes.js";
import { getEquipoByOptionsIntervenciones } from "../../../../api/EndPoints.ts";
import { buttonsDefault } from "../../../../components/ButtonsTable/ButtonsTable";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext.jsx";
import { formatearFecha } from "../../../../components/Utils/Utils.ts";
import { Typography, Box, Tooltip } from "@mui/material";
import { fonts, colors } from "../../../../assets/styles/theme.ts";
import { Search } from "@mui/icons-material";
import { CustomButton } from "../../../Task/Items/SuperAdminStyled.js";
import { RenderImgStyled } from "../../../Task/Items/SuperAdminStyled.js";
import { More } from "../../../Task/Items/SuperAdminStyled.js";
import { Info } from '@mui/icons-material';

const columns = [
  { id: "fecha", label: "Fecha" },
  { id: "tipo", label: "Tipo Intervención" },
  { id: "intervencion", label: "Intervención" },
  { id: "equipo", label: "Equipo" },
  { id: "planta", label: "Planta" },
  { id: "buttons" },
];

const buttonsHeadTable = [
  {
    label: "Nueva intervención",
    classname: "buttonHeaderTable",
  },
];

const IntervencionesClientesExternos = () => {
  const { token } = useAuth(); // Accede al token del contexto
  const { state } = useLocation();
  const row = state ? state.row : null;

  const [statusModal, setModalStatus] = useState(false);
  const [datosModal, setDatosModal] = useState("");
  const [intervenciones, setIntervenciones] = useState([]);
  const [equipos, setEquipos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [plantas, setPlantas] = useState([]);
  const [selectedOptionpla, setSelectedOptionpla] = useState(null);
  const [intervencionId, setIntevencionId] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [itemsCount, setItemsCount] = useState(1);
  const [orderBy, setOrderBy] = useState("");
  const [statusModal2, setModalStatus2] = useState(false);
  const [selectedOptionequi, setSelectedOptionequi] = useState(null); //null
  const [selectedOptioncli, setSelectedOptioncli] = useState(null); //null
  const [key, setKey] = useState(1);
  const [prefilter, setPrefilter] = useState(row ? true : false);
  const [firstRender, setFirstRender] = useState(true);
  const [reloadFlag, setReloadFlag] = useState(false);
  const [lastAction, setLastAction] = useState(null);
  //const prevStateRef = useRef({ paginaActual, orderBy, searchTerm });
  console.log(equipos);
  useEffect(() => {
    // Si token.clienteId no está vacío, solo ejecutamos getClienteOptions y setSelectedOptionCli
    if (token.clienteId !== "") {
      getClienteOptions().then((res) => {
        const clientes = res.data.map((res) => ({
          label: res.desc_cli,
          value: res.id
        }));
        setClientes(clientes);

        // Buscar y seleccionar el cliente que coincida con token.clienteId
        const clienteSeleccionado = clientes.find(cliente => cliente.value === parseInt(token.clienteId, 10));
        if (clienteSeleccionado) {
          setSelectedOptioncli(clienteSeleccionado); // Establecer el cliente seleccionado
        }
      });
    } else {
      // Si token.clienteId está vacío, ejecutamos las funciones como están ahora
      getEquiposOptions().then((res) => {
        setEquipos(
          res.data.map((res) => ({
            label: res.desc_equi,
            value: res.id,
            code: res.codigo_equi
          }))
        );
      });

      getClienteOptions().then((res) => {
        setClientes(
          res.data.map((res) => ({
            label: res.desc_cli,
            value: res.id
          }))
        );
      });

      getPlantaOptions().then((res) => {
        setPlantas(
          res.data.map((res) => ({
            label: res.desc_pla,
            value: res.id,
            subLabel: res?.cliente?.description,
          }))
        )
      })

      fetchIntervencionesPaginated(paginaActual, orderBy, searchTerm);
    }
  }, []); // Agregar dependencias necesarias

  useEffect(() => {
    if (selectedOptioncli === null) {
      getEquiposOptions().then((res) => {
        setEquipos(
          res.data.map((res) => {
            return { label: res.desc_equi, value: res.id, code: res.codigo_equi };
          })
        );
      });

      getPlantaOptions().then((res) => {
        let plantaIds = token.plantaId.split(",").map(id => Number(id.trim()));

        // Verificar si hay más de un número en la lista
        let shouldFilter = plantaIds.length > 1;

        setPlantas(
          res.data
            .filter(item => !shouldFilter || plantaIds.includes(item.id)) // Aplicar filtro solo si hay varios números
            .map((res) => ({
              label: res.desc_pla,
              value: res.id,
              subLabel: res?.cliente?.description,
            }))
        );
      });
    } else {
      setSelectedOptionequi(null)
      getEquipoByOptionsIntervenciones(selectedOptioncli.value).then((res) => {
        setEquipos(
          res.data.map((res) => {
            return { label: res.desc_equi, value: res.id, code: res.codigo_equi }
          })
        )
      })
      getPlantaByClienteOptions(selectedOptioncli.value).then((res) => {
        let plantaIds = token.plantaId.split(",").map(id => Number(id.trim()));

        // Verificar si hay más de un número en la lista
        let shouldFilter = plantaIds.length > 1;

        setPlantas(
          res.data
            .filter(item => !shouldFilter || plantaIds.includes(item.id)) // Aplicar filtro solo si hay varios números
            .map((res) => ({
              label: res.desc_pla,

              value: res.id,
              subLabel: res?.cliente?.description,

            }))
        );
      })
    }
  }, [selectedOptioncli])

  useEffect(() => {
    if (selectedOptionpla !== null) {
      // filtro por planta
      fetchIntervencionIncludingPlanta(paginaActual, orderBy, searchTerm, lastAction)
    }

    if (selectedOptioncli === null && selectedOptionequi === null && selectedOptionpla === null) {
      fetchIntervencionesPaginated(paginaActual, orderBy, searchTerm, lastAction)
      return;
    }

    if (selectedOptioncli !== null && selectedOptionequi === null && selectedOptionpla === null) {
      fetchIntervencionByCliente(selectedOptioncli.value, paginaActual, orderBy, searchTerm, lastAction);
      return;
    }

    if (selectedOptioncli === null && selectedOptionequi !== null && selectedOptionpla === null) {
      fetchIntervencionByEquipo(selectedOptionequi.value, paginaActual, orderBy, searchTerm, lastAction);
      return;
    }

    if (selectedOptioncli !== null && selectedOptionequi !== null && selectedOptionpla === null) {
      fetchIntervencionByClienteByEquipo(selectedOptioncli.value, selectedOptionequi.value, paginaActual, orderBy, searchTerm, lastAction)
      return;
    }

  }, [selectedOptioncli, selectedOptionpla, selectedOptionequi, paginaActual, orderBy, searchTerm, reloadFlag])

  // useEffect(() => {
  //   if (selectedOptioncli) {
  //     getEquiposByClientes(selectedOptioncli.value).then((res) => {
  //       setEquipos(
  //         res.data.map((res) => {
  //           return { label: res.desc_equi, value: res.id };
  //         })
  //       );
  //     });

  //     setSelectedOptionequi([]);
  //   } else {
  //     fetchIntervencionesPaginated(paginaActual, orderBy, "");
  //     setSelectedOptionequi([]);
  //   }
  // }, [selectedOptioncli]);

  // useEffect(() => {
  //   if (selectedOptionequi && selectedOptionequi.length > 0) {
  //     fetchIntervencionByEquipo(selectedOptionequi.value);
  //   }
  // }, [selectedOptionequi]);

  // useEffect(() => {
  //   fetchIntervencionesPaginated(paginaActual, orderBy, searchTerm, "");
  // }, [searchTerm, paginaActual, orderBy]);

  const handleClickButonTable = (value, valueRow) => {
    let intervencionLabel = '';
    
    try {
      intervencionLabel =
      valueRow.intervencion?.props?.children?.props?.children?.[1] || '';
    } catch (e) {
      console.log(e);
    }
   
    if (value !== "Eliminar") {
      setModalStatus(true);
      setDatosModal({
        button: value.toLowerCase(),
        datos: { ...valueRow, intervencion: intervencionLabel },
      });
    } else {
      setIntevencionId(valueRow.id);
      setModalStatus2(true);
    }
  };

  const handleClickButtonHeader = () => {
    setDatosModal("");
    setModalStatus(true);
  };

  const fetchIntervencionesPaginated = async (
    pagina,
    order,
    search,
    action
  ) => {
    const res =
      search === ""
        ? await getIntervecionPaginated(pagina, order)
        : await getIntervecionSearch(pagina, order, search);

    if (action !== "") {
      setPageCount(res.data.totalPages);
      setItemsCount(res.data.totalItems);
      if (res.data.totalPages > 0) {
        setPaginaActual(
          res.data.totalPages < paginaActual
            ? res.data.totalPages
            : paginaActual
        );
      }
    }
    if (action === "new" && intervenciones.length + 1 === 21) {
      setPaginaActual(res.data.totalPages);
    }

    if (action === "delete") {
      //setKey(key + 1);
      setMsjToast("Intervencion eliminada con exito.");
      setSuccess(true);
    }
    setIntervenciones(
      res.data.items.map((res) => {
        return {
          id: res.id,
          observaciones: res.observacion_inte,
          fecha: formatearFecha(res.fecha_inte),
          tipo: res.tipo.description,
          detallesDelEvento:res.desc_inte,
          intervencion: res.observacion_inte ? (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#163C5B",
                    color: "#ffffff",
                    border: `3px solid #66BBD3`,
                    borderRadius: 3,
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 250,
                  },
                },
                arrow: {
                  sx: {
                    color: "#fefefe",
                  },
                },
              }}
              title={
                <Box p={1}>
                  <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    Observaciones de la intervención
                  </Typography>
                  <Typography variant="body2" sx={{ maxWidth: 220 }}>
                    {res.observacion_inte ?? ""}
                  </Typography>
                </Box>
              }
              arrow
              placement="left"
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                <Info fontSize="small" sx={{ color: "#163C5B" }} />
                {res.desc_inte}
              </Box>
            </Tooltip>
          ) : res.desc_inte,
          equipo: res.equipo.description,
          planta: res.planta.description,
          cliente: res.cliente.description,
          clienteId: res.cliente.id,
          equipoId: res.equipo.id,
          plantaId: res.planta.id,
          tipoId: res.tipo.id,
        };
      })
    );
  };

  const fetchIntervencionByEquipo = async (
    id,
    pagina,
    order,
    search,
    action
  ) => {
    const res = await getIntervencionByEquipo(id, pagina, order, search);

    // console.log("Res: ", res.data.items);

    if (action !== "") {
      setPageCount(res.data.totalPages);
      setItemsCount(res.data.totalItems);
      if (res.data.totalPages > 0) {
        setPaginaActual(
          res.data.totalPages < paginaActual
            ? res.data.totalPages
            : paginaActual
        );
      }
    }

    if (action === "new" && intervenciones.length + 1 === 21) {
      setPaginaActual(res.data.totalPages);
    }

    if (action === "delete") {
      //setKey(key + 1);
      setMsjToast("Intervencion eliminada con exito.");
      setSuccess(true);
    }

    setIntervenciones(
      res.data.items.map((res) => {
        return {
          id: res.id,
          observaciones: res.observacion_inte,
          fecha: formatearFecha(res.fecha_inte),
          tipo: res.tipo.description,
          detallesDelEvento:res.desc_inte,
          intervencion: res.observacion_inte ? (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#163C5B",
                    color: "#ffffff",
                    border: `3px solid #66BBD3`,
                    borderRadius: 3,
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 250,
                  },
                },
                arrow: {
                  sx: {
                    color: "#fefefe",
                  },
                },
              }}
              title={
                <Box p={1}>
                  <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    Observaciones de la intervención
                  </Typography>
                  <Typography variant="body2" sx={{ maxWidth: 220 }}>
                    {res.observacion_inte ?? ""}
                  </Typography>
                </Box>
              }
              arrow
              placement="left"
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                <Info fontSize="small" sx={{ color: "#163C5B" }} />
                {res.desc_inte}
              </Box>
            </Tooltip>
          ) : res.desc_inte,
          equipo: res.equipo.description,
          planta: res.planta.description,
          cliente: res.cliente.description,
          clienteId: res.cliente.id,
          equipoId: res.equipo.id,
          plantaId: res.planta.id,
          tipoId: res.tipo.id,
        };
      })
    );
  };

  const fetchIntervencionByCliente = async (
    id,
    pagina,
    order,
    search,
    action
  ) => {
    const res = await getIntervencionByCliente(id, pagina, order, search);

    if (action !== "") {
      setPageCount(res.data.totalPages);
      setItemsCount(res.data.totalItems);
      if (res.data.totalPages > 0) {
        setPaginaActual(
          res.data.totalPages < paginaActual
            ? res.data.totalPages
            : paginaActual
        );
      }
    }

    if (action === "new" && intervenciones.length + 1 === 21) {
      setPaginaActual(res.data.totalPages);
    }

    if (action === "delete") {
      //setKey(key + 1);
      setMsjToast("Intervencion eliminada con exito.");
      setSuccess(true);
    }

    setIntervenciones(
      res.data.items.map((res) => {
        return {
          id: res.id,
          observaciones: res.observacion_inte,
          fecha: formatearFecha(res.fecha_inte),
          tipo: res.tipo.description,
          detallesDelEvento:res.desc_inte,
          intervencion: res.observacion_inte ? (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#163C5B",
                    color: "#ffffff",
                    border: `3px solid #66BBD3`,
                    borderRadius: 3,
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 250,
                  },
                },
                arrow: {
                  sx: {
                    color: "#fefefe",
                  },
                },
              }}
              title={
                <Box p={1}>
                  <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    Observaciones de la intervención
                  </Typography>
                  <Typography variant="body2" sx={{ maxWidth: 220 }}>
                    {res.observacion_inte ?? ""}
                  </Typography>
                </Box>
              }
              arrow
              placement="left"
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                <Info fontSize="small" sx={{ color: "#163C5B" }} />
                {res.desc_inte}
              </Box>
            </Tooltip>
          ) : res.desc_inte,
          equipo: res.equipo.description,
          planta: res.planta.description,
          cliente: res.cliente.description,
          clienteId: res.cliente.id,
          equipoId: res.equipo.id,
          plantaId: res.planta.id,
          tipoId: res.tipo.id,
        };
      })
    );
  };

  const fetchIntervencionIncludingPlanta = async (pagina, order, search, action) => {

    if (selectedOptioncli === null && selectedOptionequi === null && selectedOptionpla !== null) {
      getIntervencionWithFilters(pagina, order, search, "", selectedOptionpla.value, "")
        .then((res) => {
          setPageCount(res.data.totalPages);
          setItemsCount(res.data.totalItems);
          if (res.data.totalPages > 0) {
            setPaginaActual(
              res.data.totalPages < paginaActual
                ? res.data.totalPages
                : paginaActual
            );
          }

          if (action === "new" && intervenciones.length + 1 === 21) {
            setPaginaActual(res.data.totalPages);
          }

          if (action === "delete") {
            //setKey(key + 1);
            setMsjToast("Intervencion eliminada con exito.");
            setSuccess(true);
          }

          setIntervenciones(
            res.data.items.map((res) => {
              return {
                id: res.id,
                observaciones: res.observacion_inte,
                fecha: formatearFecha(res.fecha_inte),
                tipo: res.tipo.description,
                detallesDelEvento:res.desc_inte,
                intervencion: res.observacion_inte ? (
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#163C5B",
                          color: "#ffffff",
                          border: `3px solid #66BBD3`,
                          borderRadius: 3,
                          boxShadow: 3,
                          p: 1.5,
                          maxWidth: 250,
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#fefefe",
                        },
                      },
                    }}
                    title={
                      <Box p={1}>
                        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                          Observaciones de la intervención
                        </Typography>
                        <Typography variant="body2" sx={{ maxWidth: 220 }}>
                          {res.observacion_inte ?? ""}
                        </Typography>
                      </Box>
                    }
                    arrow
                    placement="left"
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                      <Info fontSize="small" sx={{ color: "#163C5B" }} />
                      {res.desc_inte}
                    </Box>
                  </Tooltip>
                ) : res.desc_inte,
                equipo: res.equipo.description,
                planta: res.planta.description,
                cliente: res.cliente.description,
                clienteId: res.cliente.id,
                equipoId: res.equipo.id,
                plantaId: res.planta.id,
                tipoId: res.tipo.id,
              };
            })
          );
        })
    }

    if (selectedOptioncli !== null && selectedOptionequi === null && selectedOptionpla !== null) {
      getIntervencionWithFilters(pagina, order, search, selectedOptioncli.value, selectedOptionpla.value, "")
        .then((res) => {
          setPageCount(res.data.totalPages);
          setItemsCount(res.data.totalItems);
          if (res.data.totalPages > 0) {
            setPaginaActual(
              res.data.totalPages < paginaActual
                ? res.data.totalPages
                : paginaActual
            );
          }

          if (action === "new" && intervenciones.length + 1 === 21) {
            setPaginaActual(res.data.totalPages);
          }

          if (action === "delete") {
            //setKey(key + 1);
            setMsjToast("Intervencion eliminada con exito.");
            setSuccess(true);
          }

          setIntervenciones(
            res.data.items.map((res) => {
              return {
                id: res.id,
                observaciones: res.observacion_inte,
                fecha: formatearFecha(res.fecha_inte),
                tipo: res.tipo.description,
                detallesDelEvento:res.desc_inte,
                intervencion: res.observacion_inte ? (
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#163C5B",
                          color: "#ffffff",
                          border: `3px solid #66BBD3`,
                          borderRadius: 3,
                          boxShadow: 3,
                          p: 1.5,
                          maxWidth: 250,
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#fefefe",
                        },
                      },
                    }}
                    title={
                      <Box p={1}>
                        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                          Observaciones de la intervención
                        </Typography>
                        <Typography variant="body2" sx={{ maxWidth: 220 }}>
                          {res.observacion_inte ?? ""}
                        </Typography>
                      </Box>
                    }
                    arrow
                    placement="left"
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                      <Info fontSize="small" sx={{ color: "#163C5B" }} />
                      {res.desc_inte}
                    </Box>
                  </Tooltip>
                ) : res.desc_inte,
                equipo: res.equipo.description,
                planta: res.planta.description,
                cliente: res.cliente.description,
                clienteId: res.cliente.id,
                equipoId: res.equipo.id,
                plantaId: res.planta.id,
                tipoId: res.tipo.id,
              };
            })
          );
        })
    }

    if (selectedOptioncli === null && selectedOptionequi !== null && selectedOptionpla !== null) {
      getIntervencionWithFilters(pagina, order, search, "", selectedOptionpla.value, selectedOptionequi.value)
        .then((res) => {
          setPageCount(res.data.totalPages);
          setItemsCount(res.data.totalItems);
          if (res.data.totalPages > 0) {
            setPaginaActual(
              res.data.totalPages < paginaActual
                ? res.data.totalPages
                : paginaActual
            );
          }

          if (action === "new" && intervenciones.length + 1 === 21) {
            setPaginaActual(res.data.totalPages);
          }

          if (action === "delete") {
            //setKey(key + 1);
            setMsjToast("Intervencion eliminada con exito.");
            setSuccess(true);
          }

          setIntervenciones(
            res.data.items.map((res) => {
              return {
                id: res.id,
                observaciones: res.observacion_inte,
                fecha: formatearFecha(res.fecha_inte),
                tipo: res.tipo.description,
                detallesDelEvento:res.desc_inte,
                intervencion: res.observacion_inte ? (
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#163C5B",
                          color: "#ffffff",
                          border: `3px solid #66BBD3`,
                          borderRadius: 3,
                          boxShadow: 3,
                          p: 1.5,
                          maxWidth: 250,
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#fefefe",
                        },
                      },
                    }}
                    title={
                      <Box p={1}>
                        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                          Observaciones de la intervención
                        </Typography>
                        <Typography variant="body2" sx={{ maxWidth: 220 }}>
                          {res.observacion_inte ?? ""}
                        </Typography>
                      </Box>
                    }
                    arrow
                    placement="left"
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                      <Info fontSize="small" sx={{ color: "#163C5B" }} />
                      {res.desc_inte}
                    </Box>
                  </Tooltip>
                ) : res.desc_inte,
                equipo: res.equipo.description,
                planta: res.planta.description,
                cliente: res.cliente.description,
                clienteId: res.cliente.id,
                equipoId: res.equipo.id,
                plantaId: res.planta.id,
                tipoId: res.tipo.id,
              };
            })
          );
        })
    }

    if (selectedOptioncli !== null && selectedOptionequi !== null && selectedOptionpla !== null) {
      getIntervencionWithFilters(pagina, order, search, selectedOptioncli.value, selectedOptionpla.value, selectedOptionequi.value)
        .then((res) => {
          setPageCount(res.data.totalPages);
          setItemsCount(res.data.totalItems);
          if (res.data.totalPages > 0) {
            setPaginaActual(
              res.data.totalPages < paginaActual
                ? res.data.totalPages
                : paginaActual
            );
          }

          if (action === "new" && intervenciones.length + 1 === 21) {
            setPaginaActual(res.data.totalPages);
          }

          if (action === "delete") {
            //setKey(key + 1);
            setMsjToast("Intervencion eliminada con exito.");
            setSuccess(true);
          }

          setIntervenciones(
            res.data.items.map((res) => {
              return {
                id: res.id,
                observaciones: res.observacion_inte,
                fecha: formatearFecha(res.fecha_inte),
                tipo: res.tipo.description,
                detallesDelEvento:res.desc_inte,
                intervencion: res.observacion_inte ? (
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#163C5B",
                          color: "#ffffff",
                          border: `3px solid #66BBD3`,
                          borderRadius: 3,
                          boxShadow: 3,
                          p: 1.5,
                          maxWidth: 250,
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#fefefe",
                        },
                      },
                    }}
                    title={
                      <Box p={1}>
                        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                          Observaciones de la intervención
                        </Typography>
                        <Typography variant="body2" sx={{ maxWidth: 220 }}>
                          {res.observacion_inte ?? ""}
                        </Typography>
                      </Box>
                    }
                    arrow
                    placement="left"
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                      <Info fontSize="small" sx={{ color: "#163C5B" }} />
                      {res.desc_inte}
                    </Box>
                  </Tooltip>
                ) : res.desc_inte,
                equipo: res.equipo.description,
                planta: res.planta.description,
                cliente: res.cliente.description,
                clienteId: res.cliente.id,
                equipoId: res.equipo.id,
                plantaId: res.planta.id,
                tipoId: res.tipo.id,
              };
            })
          );
        })
    }

  }

  const fetchIntervencionByClienteByEquipo = async (
    idCli,
    idEquipo,
    pagina,
    order,
    search,
    action
  ) => {
    const res = await getIntervencionByClienteByEquipo(
      idCli,
      idEquipo,
      pagina,
      order,
      search
    );

    if (action !== "") {
      setPageCount(res.data.totalPages);
      setItemsCount(res.data.totalItems);
      if (res.data.totalPages > 0) {
        setPaginaActual(
          res.data.totalPages < paginaActual
            ? res.data.totalPages
            : paginaActual
        );
      }
    }

    if (action === "new" && intervenciones.length + 1 === 21) {
      setPaginaActual(res.data.totalPages);
    }

    if (action === "delete") {
      //setKey(key + 1);
      setMsjToast("Intervencion eliminada con exito.");
      setSuccess(true);
    }

    setIntervenciones(
      res.data.items.map((res) => {
        return {
          id: res.id,
          observaciones: res.observacion_inte,
          fecha: formatearFecha(res.fecha_inte),
          tipo: res.tipo.description,
          detallesDelEvento:res.desc_inte,
          intervencion: res.observacion_inte ? (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#163C5B",
                    color: "#ffffff",
                    border: `3px solid #66BBD3`,
                    borderRadius: 3,
                    boxShadow: 3,
                    p: 1.5,
                    maxWidth: 250,
                  },
                },
                arrow: {
                  sx: {
                    color: "#fefefe",
                  },
                },
              }}
              title={
                <Box p={1}>
                  <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    Observaciones de la intervención
                  </Typography>
                  <Typography variant="body2" sx={{ maxWidth: 220 }}>
                    {res.observacion_inte ?? ""}
                  </Typography>
                </Box>
              }
              arrow
              placement="left"
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                <Info fontSize="small" sx={{ color: "#163C5B" }} />
                {res.desc_inte}
              </Box>
            </Tooltip>
          ) : res.desc_inte,
          equipo: res.equipo.description,
          planta: res.planta.description,
          cliente: res.cliente.description,
          clienteId: res.cliente.id,
          equipoId: res.equipo.id,
          plantaId: res.planta.id,
          tipoId: res.tipo.id,
        };
      })
    );
  };

  const handleChangeCliente = (value) => {
    if (!value) {
      // Si se borra el valor del input, reseteamos la tabla
      setPrefilter(false);
      setSelectedOptioncli(null);

      /*if (selectedOptionequi !== null) {
        fetchIntervencionByEquipo(
          selectedOptionequi.value,
          paginaActual,
          orderBy,
          "",
          "filter"
        );
      } else {
        fetchIntervencionesPaginated(
          paginaActual,
          orderBy,
          "",
          "filter"
        );
      }*/
    } else {
      setSelectedOptioncli(value);

      /*if (selectedOptionequi !== null) {
        fetchIntervencionByClienteByEquipo(
          value.value,
          selectedOptionequi.value,
          paginaActual,
          orderBy,
          searchTerm,
          "filter"
        );
      } else {
        fetchIntervencionByCliente(
          value.value,
          paginaActual,
          orderBy,
          searchTerm,
          "filter"
        );
      }*/
    }
    setPrefilter(true);
  };

  const handleChangePlanta = (value) => {
    if (!value) {
      setPrefilter(false);
      setSelectedOptionpla(null);
    } else {
      setSelectedOptionpla(value);
    }
    setPrefilter(true);
  };

  const handleChangeEquipo = (value) => {
    if (!value) {
      setPrefilter(false);
      setSelectedOptionequi(null);
    } else {
      setSelectedOptionequi(value);
    }
    setPrefilter(true);
  };

  const handleBuscador = (value) => {
    setSearchTerm(value);
    /*if (selectedOptioncli !== null && selectedOptionequi === null) {
      fetchIntervencionByCliente(
        selectedOptioncli.value,
        paginaActual,
        orderBy,
        value,
        "search"
      );
    } else if (selectedOptioncli === null && selectedOptionequi !== null) {
      fetchIntervencionByEquipo(
        selectedOptionequi.value,
        paginaActual,
        orderBy,
        value,
        "search"
      );
    } else if (selectedOptioncli !== null && selectedOptionequi !== null) {
      fetchIntervencionByClienteByEquipo(
        selectedOptioncli.value,
        selectedOptionequi.value,
        paginaActual,
        orderBy,
        value,
        "search"
      );
    } else {
      fetchIntervencionesPaginated(paginaActual, orderBy, value, "search");
    }*/
  };

  const handleDelete = (id) => {
    deleteIntervecion(id)
      .then(() => {
        setIntevencionId("");
        let paginaActualTemp = paginaActual;
        if (intervenciones.length - 1 === 0 && paginaActual > 1) {
          paginaActualTemp = paginaActual - 1;
          setPaginaActual(paginaActualTemp);
        }
        setLastAction("delete")
        setReloadFlag(!reloadFlag)
        return;
      })
      .catch((err) => {
        //setKey(key + 1);
        setMsjToast("Error al eliminar la intervencion.");
        setError(true);
      });
  };

  const handleOrder = (value) => {
    let valor;
    if (orderBy === "" || orderBy.replace("-", "").length !== value.length) {
      valor = value;
    } else {
      valor = orderBy;
    }

    if (valor.indexOf("-") > -1) {
      const updatedValue = valor.replace("-", "");
      setOrderBy(updatedValue);
    } else {
      const updatedValue = "-" + valor;
      setOrderBy(updatedValue);
    }
  };

  return (
    <Styled>
      <div className="toast">
        {success ? (
          <Toast key={key} title={msjToast} close={() => setSuccess(false)} />
        ) : null}
        {error ? (
          <Toast
            key={key}
            type={"error"}
            title={msjToast}
            close={() => setError(false)}
          />
        ) : null}
      </div>

      <Modal
        datos={datosModal}
        isOpen={statusModal}
        onClose={({ msj, status }) => {
          setSuccess(false);
          setError(false);
          //setKey(key + 1);
          setMsjToast(msj);
          if (status === "success") {
            if (msj.includes("cread")) { setLastAction("new") }
            setSuccess(true);
            setReloadFlag(!reloadFlag)
          } else if (status === "error") {
            setError(true);
          }
          setModalStatus(false);
        }}
        type={"intervencionesClientes"}
      />

      <Typography
        sx={{
          fontFamily: fonts.primary,
          color: colors.blueDark,
          fontSize: 20,
          fontWeight: 600,
        }}
      >
        Intervenciones
      </Typography>

      <BoxHeader>
        <BoxInputs>
          <Input
            inputProp={true}
            positionIcon={"start"}
            placeholder={"Buscar por código, descripción, tipo"}
            icon={<Search />}
            size={"small"}
            search={"true"}
            className={"inputSelect"}
            value={searchTerm}
            isClearable={() => setSearchTerm("")}
            onChange={(e) => handleBuscador(e.target.value)}
          />
          {token.clienteId === "" ?
            <Input
              isClearable
              reactSelect
              placeholder={"Seleccione el Cliente"}
              options={clientes}
              stylesHeader
              onChange={(e) => handleChangeCliente(e)}
              value={selectedOptioncli}
            /> : <></>}
          {!(token.plantaId && token.plantaId.split(',').length === 1 && !isNaN(Number(token.plantaId))) ? <Input
            isClearable
            reactSelect
            placeholder={"Seleccione la Planta"}
            options={plantas}
            stylesHeader
            onChange={(e) => {
              handleChangePlanta(e);
            }}
            value={selectedOptionpla}
            showSubLabel
          /> : <></>}
          <Input
            isClearable
            reactSelect
            placeholder={"Seleccione el Equipo"}
            options={equipos}
            stylesHeader
            onChange={(e) => {
              handleChangeEquipo(e);
            }}
            value={selectedOptionequi}
            showSubLabel
          />
        </BoxInputs>
        <Box>
          <CustomButton
            label={"Nueva intervención "}
            startIcon={<RenderImgStyled img={More} />}
            variant={"contained"}
            className="buttonHeaderTable"
            onClick={(e) => {
              handleClickButtonHeader(e);
            }}
          />
        </Box>
      </BoxHeader>
      <Tables
        typeTable={"prop"}
        columns={columns}
        rows={intervenciones}
        cRows={20}
        totalRows={itemsCount}
        actualpage={paginaActual}
        pagination={true}
        onClickSwitch={(value) => {
          handleOrder(value);
        }}
        page={(e) => setPaginaActual(e + 1)}
        pages={pageCount}
        buttons={buttonsDefault}
        onClickButtonTable={(value, valuesRow) => {
          handleClickButonTable(value, valuesRow);
        }}
      // onClickSwitch={(id)=> alert(id)}
      />

      <Modal2
        type="eliminar"
        isOpen={statusModal2}
        onClose={() => setModalStatus2(false)}
        onClickSuccess={() => {
          setModalStatus2(false);
          handleDelete(intervencionId);
        }}
      />
    </Styled >
  );
};

export default IntervencionesClientesExternos;

const Styled = styled.div`
  padding: 20px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .styledTables {
    //height: 100vh;
  }
`;


export const BoxHeader = styled(Box)`
  display:flex;
  justify-Content:space-between;
  align-items: center;
  width:100%;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;
export const BoxInputs = styled(Box)`
  display:flex;
  justify-Content:space-between;
  align-items: center;
  gap: 10px;
  width:70%;
  .divInput{
    width:70%;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    .divInput{
      width: 100%;
    }
  }
`;


{/* <div className="compexterno">
  <HeaderTable
    styledHead="clientes"
    clientes
    title="Intervenciones"
    datosButtons={buttonsHeadTable}
    valueBuscador={(value) => handleBuscador(value)}
    onClickButton={() => {
      handleClickButtonHeader();
    }}
    multiInputs
    selectInput={(e) => {
      setSearchTerm(e.target.value.label);
    }}
    buttonSet={() => {
      setSearchTerm("");
    }}
    clean
    search
    value={searchTerm}
    isClearable={() => {
      setSearchTerm("");

    }}
  />
  <div className="compinterno">
    {token.clienteId === "" ?
      <Input
        isClearable
        reactSelect
        placeholder={"Seleccione el Cliente"}
        options={clientes}
        stylesHeader
        onChange={(e) => handleChangeCliente(e)}
        value={selectedOptioncli}
      /> : <></>}
    {!(token.plantaId && token.plantaId.split(',').length === 1 && !isNaN(Number(token.plantaId))) ? <Input
      isClearable
      reactSelect
      placeholder={"Seleccione la Planta"}
      options={plantas}
      stylesHeader
      onChange={(e) => {
        handleChangePlanta(e);
      }}
      value={selectedOptionpla}
    /> : <></>}
    <Input
      isClearable
      reactSelect
      placeholder={"Seleccione el Equipo"}
      options={equipos}
      stylesHeader
      onChange={(e) => {
        handleChangeEquipo(e);
      }}
      value={selectedOptionequi}
    />
  </div>
</div>  */}




//  nombre: res.observacion_inte ? (
//                 // <Tooltip title={res.desc_inte || ''}  >
//                 //   <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 //     <InfoIcon fontSize="small" sx={{ color: "#163C5B" }} /> {res.desc_inte?.slice(0, 10) + '...'}
//                 //   </Box>
//                 // </Tooltip>
//                 <Tooltip
//                   componentsProps={{
//                     tooltip: {
//                       sx: {
//                         backgroundColor: "#163C5B",
//                         color: "#ffffff",
//                         border: `3px solid #66BBD3`,
//                         borderRadius: 3,
//                         boxShadow: 3,
//                         p: 1.5,
//                         maxWidth: 250,
//                       },
//                     },
//                     arrow: {
//                       sx: {
//                         color: "#fefefe",
//                       },
//                     },
//                   }}
//                   title={
//                     <Box p={1}>
//                       <Typography variant="subtitle2" fontWeight={600} gutterBottom>
//                         Observaciones de la intervención
//                       </Typography>
//                       <Typography variant="body2" sx={{ maxWidth: 220 }}>
//                         {res.observacion_inte ?? ""}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="left"
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
//                     <Info fontSize="small" sx={{ color: "#163C5B" }} />
//                     {res.desc_inte}
//                   </Box>
//                 </Tooltip>
//               ) : res.desc_inte,